module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"videoProcessingFailed":"К сожалению, мы не смогли обработать записанное видео"}}')
  delete Component.options._Ctor
}
